<div class="SchoolGrid">
	<!--Sort Type Button-->
	<button [disabled]="IsDisabled() == true" class="btn btn-primary FitContent" (click)="onToggleSortType()">
		{{ SortType }}
	</button>

	<!--Sort Direction Button-->
	<button [disabled]="IsDisabled() == true" class="btn btn-primary FitContent" (click)="onToggleSortDirection()">
		<i *ngIf="SortDirection == 'ASC'" class="fa fa-chevron-up" aria-hidden="true"></i>
		<i *ngIf="SortDirection == 'DESC'" class="fa fa-chevron-down" aria-hidden="true"></i>
	</button>

	<!--Drop Down-->
	<p-dropdown
		[disabled]="IsDisabled() == true"
		[options]="lstSchool"
		[(ngModel)]="SelectedSchool"
		optionLabel="SchoolName"
		[filter]="true"
		filterBy="SchoolFullName"
		[showClear]="false"
		placeholder="Select a School"
		(ngModelChange)="onSchoolChange($event)"
		[ngClass]="{
			WarningText: SelectedSchool?.WarningLevelID == 1,
			ErrorText: SelectedSchool?.WarningLevelID == 2
		}"
	>
		<ng-template pTemplate="selectedItem">
			<div *ngIf="SelectedSchool">
				<div
					class="form-control NoBorder"
					style="text-align: left"
					[ngClass]="{
						WarningText: SelectedSchool.WarningLevelID == 1,
						ErrorText: SelectedSchool.WarningLevelID == 2
					}"
				>
					{{ SelectedSchool.SchoolFullName }}
				</div>
			</div>
		</ng-template>
		<ng-template let-SchoolItem pTemplate="item">
			<div>
				<div
					class="form-control NoBorder"
					style="text-align: left"
					[ngClass]="{
						WarningText: SchoolItem.WarningLevelID == 1,
						ErrorText: SchoolItem.WarningLevelID == 2
					}"
				>
					{{ SchoolItem.SchoolFullName }}
				</div>
			</div>
		</ng-template>
	</p-dropdown>
</div>
